import React from "react";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

interface InputPhoneFieldProps {
  label?: string;
  placeholder: string;
  register: UseFormRegisterReturn;
  value?: string; // pass watch("phone") here
  error?: FieldError;
  rounded?: number;
  readononly?: boolean;
}

const AdvancedPhoneField: React.FC<InputPhoneFieldProps> = ({
  label,
  placeholder,
  register,
  value = "",
  error,
  rounded = 16,
  readononly = false,
}) => {

    const formattedPhone = value ? (value.startsWith('+') ? value : `+${value}`) : '';


  return (
    <div className="mb-4 w-full">
      {label && (
        <label className="block text-sm font-semibold text-Black mb-2 capitalize">
          {label}
        </label>
      )}

      <div
        className={`phone-input border border-LightGrey3 bg-white rounded-[${rounded}px] px-3 py-2
            focus-within:ring-2 focus-within:ring-primary transition-all`}
      >
        <PhoneInput
          international
          defaultCountry="SA"
          value={formattedPhone || undefined} // undefined when empty
          onChange={(val) => register.onChange({ target: { name: register.name, value: val || "" } })}
          onBlur={register.onBlur}
          disabled={readononly}
          placeholder={placeholder}
          className="w-full text-base bg-transparent outline-none"
        />
      </div>

      {error && (
        <span className="text-danger text-sm mt-1 block">{error.message}</span>
      )}
    </div>
  );
};

export default AdvancedPhoneField;
